import React from "react";
import { Box, Paper, Table, TableContainer } from "@mui/material";

/**
 * Panelin butun tablolari icin ortak cerceve.
 *
 * Amac: her sayfanin kendi TableContainer/Table stilini yazmasi yerine tek yerden
 * ayni gorunumu ve ayni tasma davranisini vermek:
 *  - genis tablolar kesilmez, yatay kaydirma cubugu cikar (overflowX: auto)
 *  - uzun listelerde baslik satiri yapisik kalir (stickyHeader + maxHeight)
 *  - basliklar tek satirda durur, sutunlar sikismaz (minWidth)
 *
 * Tablo icerigi (TableHead/TableBody) oldugu gibi children olarak verilir;
 * hicbir sayfanin veri veya davranis mantigi degismez.
 */

export const TABLE_HEAD_SX = {
  "& .MuiTableCell-head": {
    fontWeight: 700,
    fontFamily: "Montserrat",
    fontSize: "0.8rem",
    color: "#344054",
    backgroundColor: "#F8F9FA",
    whiteSpace: "nowrap",
    borderBottom: "1px solid #eaecf0",
  },
};

export default function DataTableFrame({
  children,
  /** Sutunlarin sikismadan durabilecegi en kucuk genislik. */
  minWidth = 900,
  /** Dikey kaydirma siniri; null verilirse tablo tam boyuyla akar. */
  maxHeight = "calc(100vh - 300px)",
  /** Baslik satiri yapisik kalsin mi. */
  stickyHeader = true,
  /** MUI Table size ("small" | "medium"). */
  size,
  /** true ise kart/diyalog icinde kullanilir; kendi kagit ve cercevesini cizmez. */
  plain = false,
  /** TableContainer sx eklentisi. */
  sx = {},
  /** Table sx eklentisi. */
  tableSx = {},
  ...rest
}) {
  const containerSx = {
    width: "100%",
    maxWidth: "100%",
    overflowX: "auto",
    ...(maxHeight ? { maxHeight } : {}),
    ...(plain
      ? {}
      : {
          borderRadius: 3,
          border: "1px solid #eaecf0",
          bgcolor: "#fff",
        }),
    ...sx,
  };

  const containerProps = plain
    ? { component: Box }
    : { component: Paper, elevation: 0 };

  return (
    <TableContainer {...containerProps} sx={containerSx} {...rest}>
      <Table
        stickyHeader={stickyHeader}
        size={size}
        sx={{ minWidth, ...TABLE_HEAD_SX, ...tableSx }}
      >
        {children}
      </Table>
    </TableContainer>
  );
}
